import { request } from "utils/request";
import { AxiosPromise } from "axios";


export const bannerApi = {
    findAll: (params?: any): AxiosPromise<any> => request({
        url: '/v1/admin/banner',
        params
    }),
    create: (data: any): AxiosPromise<any> => request({
        url: '/v1/admin/banner',
        data,
        method: 'post'
    }),
    update: (id: number, data: any): AxiosPromise<any> => request({
        url: `/v1/admin/banner/${id}`,
        method: 'patch',
        data
    }),
    delete: (id: number): AxiosPromise<any> => request({
        url: `/v1/admin/banner/${id}`,
        method: 'delete'
    }),
}
